import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ChannelPartner({ warehousingChannels = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "channel_type", label: "Channel Type" },
        { key: "geography", label: "Geography" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        { key: "channel_type", label: "Channel Type" },
        { key: "geography", label: "Geography" },
        { key: "strategic_role", label: "Strategic Role" },
        { key: "risks", label: "Risks" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const dataArray = Array.isArray(warehousingChannels)
      ? warehousingChannels
      : [warehousingChannels];

    // Remove unnecessary nested fields if present
    const cleanedData = dataArray.map((item) => {
      const { warehouses, ...restResponse } = item.response || {};
      return { ...item, response: restResponse };
    });

    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={warehousingChannels?.[0]?.response?.tableComments || ""}
      />
    );
  }, [warehousingChannels]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  if (tabData.length === 0) {
    return <></>;
  }

  return (
    <InsightTable
      title="Channel Partner"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="partner_name"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default ChannelPartner;
